export type SimType = "sim" | "esim" | "keep_current";
export type SimDeliveryType = "from_store" | "sent_home";

export const SIM_NUMBER_LENGTH = 20;
export const SIM_NUMBER_MAX_LENGTH = SIM_NUMBER_LENGTH;

const SIM_NUMBER_REGEX = /^\d{20}$/;

const isValidLuhn = (value: string): boolean => {
    if (!/^\d+$/.test(value)) {
        return false;
    }

    let sum = 0;
    let shouldDouble = false;

    for (let i = value.length - 1; i >= 0; i -= 1) {
        let digit = Number(value[i]);

        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }

        sum += digit;
        shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
};

export const isValidSimNumber = (value: string): boolean => SIM_NUMBER_REGEX.test(value) && isValidLuhn(value);

export const getSimNumberError = (value: string): string | undefined => {
    if (!value) {
        return "SIM-nummer må fylles ut.";
    }

    if (!/^\d+$/.test(value)) {
        return "SIM-nummer kan kun inneholde sifre.";
    }

    if (value.length !== SIM_NUMBER_LENGTH) {
        return `SIM-nummer må være ${SIM_NUMBER_LENGTH} siffer.`;
    }

    if (!isValidLuhn(value)) {
        return "SIM-nummer er ugyldig. Kontroller at du har skrevet inn riktig.";
    }

    return undefined;
};
